(function () {
  'use strict';

  angular.module('ringbaPortal').component('ivrAssets', {
    controller: IvrAssetsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/ivrs/ivr-assets.view.html'
  });

  function IvrAssetsController() {
    'ngInject';
  }
})();
